module.exports = __webpack_public_path__ + "img/icon_arrow.03ba585c.svg";